"use client";
import { QuoteProvider } from "@/contexts/QuoteContext";
import React, { PropsWithChildren } from "react";

const AuthLayout = ({ children }: PropsWithChildren) => {
  return (
    <QuoteProvider>
      <div className="flex justify-center items-center w-full h-[100vh] bg-gradient-to-tr from-amber-400 to-white">
        {children}
      </div>
    </QuoteProvider>
  );
};

export default AuthLayout;
